import { useState } from 'react';

export default function useSubTableWidth() {
  const [subTableWidth, setSubTableWidth] = useState<string | number>('auto');
  const observeTableSize = (width: number) => {
    setSubTableWidth(width);
  };

  return {
    subTableWidth,
    observeTableSize,
  };
}
